import { get, sync } from 'vuex-pathify';
export default {
  computed: {
    currentLayer: sync('layers/currentLayer'),
    layersAll: get('layers/layers'),
    projectElements: get('layers/project@layers'),
    projectLayers() {
      return this.$_getFlatGroupsLayers(this.projectElements).layers;
    },
    refreshTypesDict() {
      return {
        main: {
          'datasource-details': ['project-soft'],
          // 'datasource-attributes' -> 'default-all'
          'datasource-descs': [], // do nothing
          'datasource-advanced_expressions': ['table-hard', 'featureCard-soft', 'project-soft'],
          'layer-details': ['featureCard-hard', 'project-hard'],
          'layer-feature_card': ['featureCard-hard'],
          'layer-filters': ['table-hard', 'project-soft'],
          'layer-permissions': [], // do nothing
          'layer-symbolization': [], // do nothing
          'default-all': ['table-hard', 'featureCard-hard', 'project-hard'],
        },
        sheets: {
          'datasource-details': ['sheets-featureCard'],
          // 'datasource-attributes' -> 'default-all'
          'datasource-descs': [], // do nothing
          // 'datasource-advanced_expressions' -> 'default-all'
          // 'layer-details' -> 'default-all'
          // 'layer-feature_card' -> 'default-all'
          'layer-filters': ['sheets-table'],
          'layer-permissions': [], // do nothing
          'layer-symbolization': ['sheets-featureCard'],
          'default-all': ['sheets-featureCard', 'sheets-table'],
        },
      };
    },
    refreshFunctionsDict() {
      return {
        // 'table-filters': () => {
        //   // Clear only table filters
        //   this.$root.$emit('toggleFilterClearAction');
        // },
        'table-soft': ({ dataSourceName }) => {
          // Refresh only table data
          if (dataSourceName !== this.currentLayer?.data_source_name) return;
          this.$root.$emit('refreshTableData');
        },
        'table-hard': ({ dataSourceName }) => {
          // Reload whole table with filters, selection, sorting etc.
          if (dataSourceName !== this.currentLayer?.data_source_name) return;
          this.$root.$emit('toggleFilterClearAction');
          this.currentLayer = JSON.parse(JSON.stringify(this.layersAll[this.currentLayer.id]));
        },
        'featureCard-soft': ({ dataSourceName }) => {
          if (dataSourceName !== this.currentLayer?.data_source_name) return;
          // Cancel editing and refresh values in form data
          this.$root.$emit('cancelEditing');
          this.$root.$emit('refreshFormData');
        },
        'featureCard-hard': ({ dataSourceName }) => {
          if (dataSourceName !== this.currentLayer?.data_source_name) return;
          // Reload whole feature card
          this.currentLayer = JSON.parse(JSON.stringify(this.layersAll[this.currentLayer.id]));
          this.$nextTick(() => {
            this.$root.$emit('tableDataFetched');
          });
        },
        'project-soft': ({ dataSourceName }) => {
          // Refresh all active project layers on map and legend (by datasource)
          const layersIds = [];
          this.projectLayers.forEach(layer => {
            if (layer.data_source_name === dataSourceName) {
              layersIds.push(layer.id);
              this.$root.$emit('refreshMvtSource', layer.id);
            }
          });
          this.$root.$emit('updateLegendStylesCounts', { layersIds });
        },
        'project-hard': () => {
          // Reload whole project
          this.$root.$emit('projectChanged', { e: this.currentProject, withRouterParse: true, force: true });
        },
        'sheets-table': () => {
          // Reload sheets table and filters
          this.$emit('filterDataHandler');
        },
        'sheets-featureCard': () => {
          // Reload sheets feature card
          this.$emit('refreshFeatureCard', true);
        },
      };
    },
  },
  methods: {
    onManagerSave({ actions = [], dataSourceName = this.currentLayerDataSourceName, view = 'main' } = {}) {
      const typesFunctions = actions
        .reduce((total, current) => {
          const refreshType = this.refreshTypesDict[view][current] || this.refreshTypesDict[view]['default-all'];
          total = Array.from(new Set([...total, ...refreshType]));
          return total;
        }, [])
        .filter((element, index, arr) => {
          const [type, subtype] = element.split('-');
          if (subtype === 'hard') return true;
          else if (subtype === 'soft') return arr.indexOf(`${type}-hard`) === -1;
          return true;
        });
      typesFunctions.forEach(refreshType => this.refreshFunctionsDict[refreshType]({ dataSourceName }));
    },
  },
};
